import { o_util } from "@gr-common/async/namespaces";
import { otto } from "@gr-exports/async/nexus";
const onex = o_util.onex ?? {};
const isOnexVariant = onex.isOnexVariant;
const mapOnexVariant = onex.mapOnexVariant;
const withOnex = onex.withOnex;
const customAssignments = onex.customAssignments;
const onexAsync = otto.onex ?? {};
const assignments = onexAsync.assignments;
export {
  assignments,
  customAssignments,
  isOnexVariant,
  mapOnexVariant,
  onex,
  onexAsync,
  withOnex
};
